/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { any, bool } from 'prop-types';
import AccertifyScript from './AccertifyScript';
import { AccertifyProvider } from './AccertifyContext';

const AccertifyWrapper = ({ children, isAccertifyEnabled }) => {
    if (isAccertifyEnabled) {
        return (
            <AccertifyProvider>
                <AccertifyScript />
                {children}
            </AccertifyProvider>
        );
    }

    return children;
};

AccertifyWrapper.propTypes = {
    children: any.isRequired,
    isAccertifyEnabled: bool.isRequired,
};

export default AccertifyWrapper;
